import { injectReducer } from '../../../../../store/reducers'
import { authCheck } from '../../../../../utils/auth'
// import { loadState, saveState } from '../../../../../utils/localStorage'

// const persistedState = loadState();

export default (store) => ({
  onEnter: (nextState, replace) => {
    // console.log('onEnter!!!');
    authCheck(nextState, replace);
    // console.log('on Enter store state:', store.getState());
    // if (persistedState === undefined) {
    //   // saveState(store.getState());
    // } else {
    //   console.log('persistedState not undefined');
    // }
  },
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const InfoView = require('./containers/InfoContainer').default
      const reducer = require('../../../modules/app').default
      // console.log('getComponent persistedState:', persistedState);
      // store.setState(persistedState);
      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'app', reducer })
      /*  Return getComponent   */
      cb(null, InfoView)

    /* Webpack named bundle   */
    }, 'Application')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Home/routes/ContractResults/Info/index.js